import { createElement } from "react";
import { createRoot, type Root } from "react-dom/client";
import type { NavigationMode } from "@/actionManager/actionManager";
import { canv } from "@/canv/global";
import styles from "./NavigationSelectWindow.module.css";
import { NavigationWindowLayout } from "./NavigationWindowLayout";

export class NavigationSelectWindow {
    async open() {
        const navigationSelectWindowWrapper = document.createElement("div");
        navigationSelectWindowWrapper.classList.add(styles.navigationSelectWindowWrapper);

        this.navigationSelectWindowWrapper = navigationSelectWindowWrapper;
        document.body.prepend(navigationSelectWindowWrapper);

        this.root = createRoot(navigationSelectWindowWrapper);

        this.render();
    }

    render() {
        const NavigationWindowLayoutElement = createElement(NavigationWindowLayout, {
            mode: this.mode,
            onSelect: (mode: NavigationMode) => {
                this.mode = mode;
                this.render();
            },
            onSave: () => {
                canv.actionManager.setMode(this.mode);
                this.close();
            },
        });

        if (this.root) {
            this.root.render(NavigationWindowLayoutElement);
        } else {
            throw new Error("NavigationWindow can't find this.root");
        }
    }

    close() {
        this.root?.unmount();

        if (this.navigationSelectWindowWrapper?.parentNode) {
            this.navigationSelectWindowWrapper.parentNode.removeChild(
                this.navigationSelectWindowWrapper,
            );
            this.navigationSelectWindowWrapper = null;
        }
    }

    root: Root | null = null;
    mode: NavigationMode = "mouse";
    navigationSelectWindowWrapper: HTMLElement | null = null;
}
